(function() { module.exports = window["Bernie_l10nBundle_nl_NL"]; }());